/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var common_pb = require('./common_pb.js');
goog.exportSymbol('proto.ori.telecomms.proto.RouteProposal', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.RouteProposal.RoutePlanResult', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.RouteProposal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ori.telecomms.proto.RouteProposal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.RouteProposal.displayName = 'proto.ori.telecomms.proto.RouteProposal';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.RouteProposal.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.RouteProposal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.RouteProposal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.RouteProposal.toObject = function(includeInstance, msg) {
  var f, obj = {
    utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cmdheader: (f = msg.getCmdheader()) && common_pb.ControlCommandHeader.toObject(includeInstance, f),
    result: jspb.Message.getFieldWithDefault(msg, 3, 0),
    waypoints: (f = msg.getWaypoints()) && common_pb.WaypointList.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.RouteProposal}
 */
proto.ori.telecomms.proto.RouteProposal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.RouteProposal;
  return proto.ori.telecomms.proto.RouteProposal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.RouteProposal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.RouteProposal}
 */
proto.ori.telecomms.proto.RouteProposal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = new common_pb.ControlCommandHeader;
      reader.readMessage(value,common_pb.ControlCommandHeader.deserializeBinaryFromReader);
      msg.setCmdheader(value);
      break;
    case 3:
      var value = /** @type {!proto.ori.telecomms.proto.RouteProposal.RoutePlanResult} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 4:
      var value = new common_pb.WaypointList;
      reader.readMessage(value,common_pb.WaypointList.deserializeBinaryFromReader);
      msg.setWaypoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.RouteProposal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.RouteProposal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.RouteProposal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.RouteProposal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCmdheader();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.ControlCommandHeader.serializeBinaryToWriter
    );
  }
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getWaypoints();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.WaypointList.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.ori.telecomms.proto.RouteProposal.RoutePlanResult = {
  SUCCESS: 0,
  UNKNOWN_FAILURE: 1,
  NOT_IN_LANE: 2,
  NO_ROUTE_TO_DESTINATION: 3,
  WAYPOINT_NOT_FOUND: 4,
  NOT_LOCALIZED: 5
};

/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.ori.telecomms.proto.RouteProposal.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.ori.telecomms.proto.RouteProposal.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ControlCommandHeader cmdHeader = 2;
 * @return {?proto.ori.telecomms.proto.ControlCommandHeader}
 */
proto.ori.telecomms.proto.RouteProposal.prototype.getCmdheader = function() {
  return /** @type{?proto.ori.telecomms.proto.ControlCommandHeader} */ (
    jspb.Message.getWrapperField(this, common_pb.ControlCommandHeader, 2));
};


/** @param {?proto.ori.telecomms.proto.ControlCommandHeader|undefined} value */
proto.ori.telecomms.proto.RouteProposal.prototype.setCmdheader = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.ori.telecomms.proto.RouteProposal.prototype.clearCmdheader = function() {
  this.setCmdheader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ori.telecomms.proto.RouteProposal.prototype.hasCmdheader = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RoutePlanResult result = 3;
 * @return {!proto.ori.telecomms.proto.RouteProposal.RoutePlanResult}
 */
proto.ori.telecomms.proto.RouteProposal.prototype.getResult = function() {
  return /** @type {!proto.ori.telecomms.proto.RouteProposal.RoutePlanResult} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.ori.telecomms.proto.RouteProposal.RoutePlanResult} value */
proto.ori.telecomms.proto.RouteProposal.prototype.setResult = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional WaypointList waypoints = 4;
 * @return {?proto.ori.telecomms.proto.WaypointList}
 */
proto.ori.telecomms.proto.RouteProposal.prototype.getWaypoints = function() {
  return /** @type{?proto.ori.telecomms.proto.WaypointList} */ (
    jspb.Message.getWrapperField(this, common_pb.WaypointList, 4));
};


/** @param {?proto.ori.telecomms.proto.WaypointList|undefined} value */
proto.ori.telecomms.proto.RouteProposal.prototype.setWaypoints = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.ori.telecomms.proto.RouteProposal.prototype.clearWaypoints = function() {
  this.setWaypoints(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ori.telecomms.proto.RouteProposal.prototype.hasWaypoints = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.ori.telecomms.proto);
